/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Scan_Preview_HelpInputs */

const en_mobile_scan_preview_help = /** @type {(inputs: Mobile_Scan_Preview_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This is the page that will be converted. Pinch to check the text; adjust the crop or retake if needed.`)
};

const es_mobile_scan_preview_help = /** @type {(inputs: Mobile_Scan_Preview_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta es la página que se convertirá. Amplía para comprobar el texto; ajusta el recorte o vuelve a tomar la foto si hace falta.`)
};

/**
* | output |
* | --- |
* | "This is the page that will be converted. Pinch to check the text; adjust the crop or retake if needed." |
*
* @param {Mobile_Scan_Preview_HelpInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_scan_preview_help = /** @type {((inputs?: Mobile_Scan_Preview_HelpInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Scan_Preview_HelpInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_scan_preview_help(inputs)
	return en_mobile_scan_preview_help(inputs)
});